<template>
  <bkklist />
</template>

<script>
import Vue from 'vue'
import bkklist from '@/components/BkklistHome.vue'

export default {
  name: 'BkklistHome',
  components: {
    bkklist
  }
}
</script>
